module.exports = __webpack_public_path__ + "img/filter.d7014537.svg";